import React, { useState } from 'react'
export const ProcessesContext = React.createContext()

export const ProcessesContextProvider = ({ children }) => {
  const [processes, setProcesses] = useState([])
  const [status, setStatus] = useState('NONE')
  const [processRetry, setProcessRetry] = useState(0)

  function fetchProcesses() {
    setProcessRetry(prev => prev + 1)
  }

  return (
    <ProcessesContext.Provider
      value={{
        processes,
        setProcesses,
        status,
        setStatus,
        processRetry,
        fetchProcesses,
      }}
    >
      {children}
    </ProcessesContext.Provider>
  )
}
